export default "__VITE_ASSET__pePBrnP$__"